/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.railOuter)
  position absolute
  left 0
  top 0
  bottom 0
  z-index 2000
  transition width .3s

:local(.rail)
  position relative
  flex-shrink 0
  border-right solid 1px $spectrum-alias-dropshadow-color
  padding 8px
  height calc(100% - 16px)
  overflow-y scroll
  background-color $spectrum-alias-background-color-default

:local(.railToggle)
  position absolute
  right -8px
  pointer-events all
  cursor col-resize
  width 16px
  top 0
  bottom 0

:local(.railNav)
  transition width .3s
  white-space nowrap
  overflow hidden
  > :global(.spectrum-Heading)
    margin-left 8px

:local(.buttonBar)
  align-items center
  background-color $spectrum-alias-background-color-default
  border-right solid 1px $spectrum-alias-dropshadow-color
  border-top solid 1px $spectrum-alias-dropshadow-color
  bottom 0
  box-sizing border-box
  display flex
  flex-direction column
  height 53px
  justify-content center
  left 0
  position absolute
  width 100%
  > div
    margin-top 6px
    margin-bottom 6px

:local(.smallRail):local(.railOuter)
  width 52px
  :local(.railNav)
    width 32px

:local(.isConfigure)
  :local(.rail)
    height calc(100% - 69px)

:local(.header)
  margin-bottom 0px
  padding 0px 40px

:local(.pluginHead)
  display flex
  justify-content space-between
  align-items center
  margin-bottom -8px

:local(.redIcon)
  color $spectrum-global-color-red700
